function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useState } from 'react';

const PageSettingsField = props => {
  const uiSchema = props.uiSchema,
        formData = props.formData,
        formContext = props.formContext,
        registry = props.registry;
  const dialog = formContext.dialog,
        preview = formContext.preview,
        sidebar = formContext.sidebar;

  const newUiSchema = _extends({}, uiSchema, {
    "ui:dialog": dialog,
    "ui:preview": preview,
    "ui:sidebar": _extends({}, dialog, {}, sidebar),
    "ui:layout": "pageSettings"
  });

  const ObjectField = registry.fields.ObjectField;
  return React.createElement(ObjectField, _extends({}, props, {
    uiSchema: newUiSchema
  }));
};

export default PageSettingsField;